import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  additionalActions?: React.ReactNode;
  disabled?: boolean;
  additionalFilters?: React.ReactNode;
}

export function DataTableToolbar<TData>({
  table,
  additionalActions,
  disabled = false,
  additionalFilters,
}: DataTableToolbarProps<TData>) {
  const { t } = useTranslation();
  const isFiltered =
    table.getState().columnFilters.length > 0 ||
    table.getState().globalFilter?.length > 0;

  return (
    <div className="flex justify-between items-center space-x-2">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder={t("components.dataTable.toolbar.filter")}
          value={(table.getState().globalFilter as string) ?? ""}
          onChange={(event) => table.setGlobalFilter(event.target.value)}
          className="h-8 w-[150px] lg:w-[250px] bg-background"
          disabled={disabled}
        />

        {additionalFilters}

        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => {
              table.resetColumnFilters();
              table.setGlobalFilter("");
            }}
            className="px-2 h-8 lg:px-3"
          >
            {t("components.dataTable.toolbar.reset")}
            <Cross2Icon className="ml-2 w-4 h-4" />
          </Button>
        )}
      </div>

      {additionalActions}

      <DataTableViewOptions table={table} />
    </div>
  );
}
